<template>
  <div id="app" style="height:100%;">
    <img :src="loveswayIndexBack" class="lovesway-index-img" @click="pageClick()">
    <!-- 头部下载条 -->
    <div v-if="isDownloadShow && !isWeiXin" class="lovesway-download-line">
      <img class="lovesway-download-close-img" src="../../../assets/close.png" @click="closeDownloadLine()">
      <img class="lovesway-download-app-img" src="../../../assets/appicon.png">
      <div class="lovesway-download-text">中国婚博会APP</div>
      <div class="lovesway-download-btn" @click="gotoDownload()">下载</div>
    </div>

    <div v-if="popShow" class="lovesway-index-message-pop">{{popMessage}}</div>
  </div>
</template>

<script>
import axios from 'axios'
import GLOBAL from '../../../components/lovesway/Global'
import appCall from '../../../../plugins/appCall.js'
import browers from '../../../../plugins/browser.js'
import AppCalls from '../utils/appcall.js'

window.HBHThat = ''

import 'mint-ui/lib/style.css'
import callapp from 'callapp'
export default {
  beforeMount() {},
  mounted() {
    var that = this
    // 隐藏app关闭按钮
    callapp('uiCloseBtn', { hide: 'true' })
    HBHThat = this
    // 设置标题
    document.title = '2021我的爱情关键词'
    // 判断是否为app内
    that.isDownloadShow = !browers().isApp
    // 如果在app内
    if (browers().isApp) {
      // 设置右上角按钮为分享
      GLOBAL.navBtnR('1', '分享')
      // 微信浏览器
    } else if (GLOBAL.isWeiXin()) {
      // 获取微信配置
      GLOBAL.weixinInit(location.href, wx)
    }
    // 是否在微信浏览器
    that.isWeiXin = GLOBAL.isWeiXin()
    GLOBAL.setCookie('lovesway-back', '')
    GLOBAL.setCookie('lovesway-openId', '')

    // 对应长屏手机
    if (screen.height / screen.width > 1.7) {
      that.loveswayIndexBack =
        'https://img.hbhcdn.com/dmp/other/1576080000/jh-img-orig-ga_1205055402597056512_1125_2348_457431.gif'
    } else {
      
      that.loveswayIndexBack =
        'https://img.hbhcdn.com/dmp/other/1575907200/jh-img-orig-ga_1204305039216508928_750_1206_176065.gif'
    }

    // 进入页面数据上报
    window.$action = new postdata({ 
      appkey: 'hunbasha_wap',
      pageName:location.pathname,
      sensor_option:{
        openAll:true
      }
    })
  },
  data() {
    return {
      loveswayIndexBack: '',
      isInApp: false,
      popShow: false,
      popMessage: '',
      isWeiXin: false,
      isDownloadShow: false, // true：不显示 false：显示
      cityId: 0, // 城市ID
      token: '' // token
    }
  },

  methods: {
    /**
     * 关闭下载行
     */
    closeDownloadLine() {
      var that = this
      that.isDownloadShow = false
    },
    /**
     * 下载
     */
    gotoDownload() {
      appCall.active({
        url: 'ciw://tab/home',
        isdownload: true,
        gourl: ''
      })
    },
    /**
     * 获取token和城市ID
     */
    getTokenAndCity() {
      var that = this
      // 城市ID
      that.cityId = GLOBAL.getCookie('city-id')
      // token
      that.token = GLOBAL.getCookie('Authorization')
    },
    pageClick() {
      var that = this
      // 在app内
      if (browers().isApp) {
        // 获取token和城市ID
        that.getTokenAndCity()
        // 未登录
        if (!that.token) {
          // 跳转登录
          AppCalls.callapp('loginApp', {}, 'HBHThat.loginAppCB')
        } else {
          location.assign('role.html')
        }
      } else {
        // 微信浏览器
        if (GLOBAL.isWeiXin()) {
          if (GLOBAL.DEV_MODE) {
            location.assign('role.html')
          } else {
            // 婚博会微信授权
            that.wxLoginForJiehun()
          }
        } else {
          // 设置未登录提示信息
          that.popMessage = '请打开婚芭莎app体验'
          // 显示未登录信息提示弹窗
          that.popShow = true
          // 显示下载条
          that.isDownloadShow = true
          // 1秒后自动关闭提示弹窗
          setTimeout(that.closePop, 1000)
        }
      }
    },
    /**
     * 关闭提示弹窗
     */
    closePop() {
      var that = this
      that.popMessage = ''
      that.popShow = false
    },
    wxLogin() {
      var that = this
      var requestData = {}
      // 微信授权
      axios
        .post(GLOBAL.getUrlDomainForLovesway() + 'getWxLoginUrl', requestData, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            Authorization: that.token
          }
        })
        .then(function(response) {
          var code = response.data.code
          // 成功
          if (code === 0) {
            location.href = response.data.data.url
          } else {
            that.popShow = true
            that.popMessage = response.data.message
            setTimeout(that.closePop, 1000)
            return
          }
        })
        .catch(function() {})
    },
    /**
     * 婚博会微信授权登录
     */
    wxLoginForJiehun() {
      var state = 'userinfo' //静默授权：base,强制授权：userinfo
      var scope = 'snsapi_userinfo' //静默授权：snsapi_base,强制授权：snsapi_userinfo
      var url = encodeURIComponent(
        'http://bj.jiehun.com.cn/util/wechat/redirect/' +
          btoa(encodeURIComponent(location.origin + '/lovesway/role.html')) +
          '?url_encode=1'
      )
      var wxAuthUrl =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx496b7f5a2e2158f1&redirect_uri=' +
        url +
        '&response_type=code&scope=' +
        scope +
        '&state=' +
        state +
        '#wechat_redirect'
      // 无code，跳转授权地址取code
      location.href = wxAuthUrl
    }
  }
}
</script>

<style>
html {
  height: 100%;
}
body {
  margin: 0px !important;
  height: 100%;
}
/* 主页背景 */
.lovesway-index-img {
  width: 100%;
  height: 100%;
  vertical-align: top;
}
/* 信息提示框 */
.lovesway-index-message-pop {
  width: 20rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
  font-family: 'PingFangSC-Regular';
  border-radius: 1rem;
  color: #f5f8fa;
  font-size: 1.6rem;
  position: fixed;
  top: 33.5rem;
  left: 8.75rem;
  background-color: #333333;
  opacity: 0.9;
  z-index: 10;
}
/* 头部下载条 */
.lovesway-download-line {
  width: 100%;
  height: 5rem;
  background-color: #f6f6f6;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  text-align: left;
  display: flex;
}
/* 头部下载关闭按钮 */
.lovesway-download-close-img {
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 1.9rem;
  margin-left: 1.5rem;
  margin-right: 1rem;
}
/* 头部下载ICON */
.lovesway-download-app-img {
  width: 3.5rem;
  height: 3.5rem;
  margin-top: 0.75rem;
}
/* 头部下载文字描述 */
.lovesway-download-text {
  width: 20rem;
  height: 2rem;
  margin-top: 1.5rem;
  margin-left: 1rem;
  color: #333333;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
}
/* 头部下载按钮 */
.lovesway-download-btn {
  width: 7rem;
  height: 3rem;
  margin-top: 1rem;
  border-radius: 1.5rem;
  font-size: 1.5rem;
  line-height: 3rem;
  text-align: center;
  color: #ff6363;
  border: 1px solid #ff6363;
}
/* 首页人物动图 */
.lovesway-index-gif {
  width: 100%;
  height: 37.5rem;
  position: absolute;
  bottom: 0rem;
  left: 0rem;
  z-index: 2;
}
/* 首页人物红色go图案 */
.lovesway-index-go {
  width: 28.5rem;
  height: 4.1rem;
  position: absolute;
  bottom: 2.3rem;
  left: 4.5rem;
  z-index: 3;
}
</style>
